
import { Component, Vue, Watch } from 'vue-property-decorator'
import globalHeader from '@/components/globalHeader.vue'
import { initGlobalCustomerService } from './utils/global-customer-service'
import { TabList } from '@/constants'
import '@/utils/transformPx'
import ScrollGlobalHeaderVue from './components/ScrollGlobalHeader.vue'
import ClienteleServicesDialog from './components/ClienteleServicesDialog.vue'
@Component({
    name: 'Home',
    components: {
        globalHeader,
        ScrollGlobalHeaderVue,
        ClienteleServicesDialog
    }
})
export default class extends Vue {
    private currentTab = '1'
    private tabList = TabList
    get currentTabList() {
        if(this.$isLogin) {
            return this.tabList
        } else {
            return this.tabList.filter(item => item.id !== '4')
        }
    }
    private changeTab() {
        switch (this.currentTab) {
            case '1': this.$jump('/Question'); break
            case '2': this.$jump('/Video'); break
            case '3': this.$jump('/Novice'); break
            case '4': this.$jump('/Download'); break
            default: break
        }
    }
    get isNavPage() {
        const name = this.$route.name as string
        return ['Novice', 'Download', 'QuestionContents', 'VideoList', 'QuestionDetail', 'VideoDetail'].includes(name)
    }
    get isShowNav() {
        const name = this.$route.name as string
        return !['document', 'videoPlayer'].includes(name)
    }
    get isShowScrollNav() {
        const name = this.$route.name as string
        return !['feedback', 'SearchResult','allVideo', 'allDocument'].includes(name)
    }
    get isFeedback() {
        return this.$route.name === 'feedback'
    }
    private initTab() {
        const name = this.$route.name as string
        switch (name) {
            case 'Novice': this.currentTab = '3'; break
            case 'Download': this.currentTab = '4'; break
            case 'QuestionDetail': ;
            case 'QuestionContents': this.currentTab = '1'; break
            case 'VideoList': ;
            case 'VideoDetail': this.currentTab = '2'; break
            default: break
        }
    }
    @Watch('$route')
    private onRouteChange() {
        this.initTab()
    }
    mounted() {
        initGlobalCustomerService()
        this.initTab()
    }
    created() {
        const userId = this.$route.query.userId
        const ntwId = this.$route.query.ntwId
        if (userId) {
            localStorage.setItem('userId', userId as string)
        }
        if (ntwId) {
            localStorage.setItem('ntwId', ntwId as string)
        }
    }
}

